// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2uuxy","text":"SelectPayment_text__357L6","title":"SelectPayment_title__2-7TK","btn":"SelectPayment_btn__242Rz"};